import { RESET_BILL_OF_MATERIAL, SET_BOM_CHARGES, SET_BOM_DATA, SET_BOM_DETAILS, SET_BOM_FINISHED_GOOD_ITEMS, SET_BOM_PRODUCTION_PROCESS, SET_BOM_RAW_MATERIAL_ITEMS, SET_BOM_SCRAP_LOG_ITEMS, SET_EDIT_BOM_DATA } from "../../../../types/UI/ProductionSection/BillOfMaterial/createBOM";

const initialState = {
  bomDetails: null,
  productionProcess: null,
  finishedGoodItems: null,
  rawMaterialItems: null,
  scrapLogItems: null,
  additionalCharges: null,
};

export interface IAction {
  type: string;
  payload?: any;
}

const createBOMDetailsUIReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case SET_BOM_DETAILS:
      return {
        ...state,
        bomDetails: action.payload,
      };

    case SET_BOM_PRODUCTION_PROCESS:
      return {
        ...state,
        productionProcess: action.payload,
      };

    case SET_BOM_FINISHED_GOOD_ITEMS:
      return {
        ...state,
        finishedGoodItems: action.payload,
      };

    case SET_BOM_RAW_MATERIAL_ITEMS:
      return {
        ...state,
        rawMaterialItems: action.payload,
      };

    case SET_BOM_SCRAP_LOG_ITEMS:
      return {
        ...state,
        scrapLogItems: action.payload,
      };

    case SET_BOM_CHARGES:
      return {
        ...state,
        additionalCharges: action.payload,
      };

    case SET_BOM_DATA:
      return {
        ...state,
        bomDetails: action.payload?.bomDetails ?? {},
        productionProcess: action.payload?.productionProcess ?? [],
        finishedGoodItems: action.payload?.finishedGoodItems ?? [],
        rawMaterialItems: action.payload?.rawMaterialItems ?? [],
        scrapLogItems: action.payload?.scrapLogItems ?? [],
        additionalCharges: action.payload?.additionalCharges ?? [],
        attachments: action.payload.attachments, 
      };

    case SET_EDIT_BOM_DATA:
      return {
        ...state,
        bomDetails: action.payload?.bomDetails ?? {},
        productionProcess: action.payload?.productionProcess ?? [],
        finishedGoodItems: action.payload?.finishedGoodItems ?? [],
        rawMaterialItems: action.payload?.rawMaterialItems ?? [],
        scrapLogItems: action.payload?.scrapLogItems ?? [],
        additionalCharges: action.payload?.additionalCharges ?? [],
        attachments: action.payload.attachments, 
      };

    case RESET_BILL_OF_MATERIAL:
      return initialState;

    default:
      return state;
  }
};

export default createBOMDetailsUIReducer;
